import urls from "api/urls";
import enakonFavicon from "Asset/Images/enakonFavicon.png";
import enakonLogoMain from "Asset/Images/enakonLogo.png";
import leaftechNavLooperBG from "Asset/Images/NavLooperBG.png";
import LooperEnakon from "Asset/LooperEnakon.jpg";
import { glassLoginLayout } from "design-system/strategies/loginLayout";
import { enakonLoginParticlesOptions } from "features/white-labeling/enakon/lib/configs";

export const enakonTheme = {
  clientDisplayName: "Enakon",
  favicon: "/enakonFavicon.png",
  fonts: {
    heading: "PT Sans Narrow",
    primary: "PT Sans Narrow",
  },
  links: {
    website: urls.redirects.clientWebsite,
  },
  login: {
    layout: glassLoginLayout,
    particles: enakonLoginParticlesOptions,
  },
  logo: {
    alt: "Enakon",
    href: urls.redirects.clientWebsite,
    mainSrc: enakonLogoMain,
    sidebarSrc: enakonFavicon,
  },

  logoLooper: {
    croppedSrc: LooperEnakon,
    lgSrc: LooperEnakon,
  },
  name: "enakon",
  navLooper: {
    src: leaftechNavLooperBG,
  },
};
